// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { useState, useEffect } from "react";
// import Select from "react-select";
// import { studentattendanceInputs } from "../../formSource";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const statusoptions = [
//   { value: 0, label: "Absent" },
//   { value: 1, label: "Present" },
//   { value: 2, label: "Late" },
//   { value: 3, label: "Leave" },
//   { value: 4, label: "Half Leave" },
// ];
// const getCurrentDate = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = String(now.getMonth() + 1).padStart(2, "0");
//   const day = String(now.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// };
// const StudentAttendanceNew = ({ title }) => {
//   // const [file, setFile] = useState("");\\
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({
//     attendance_date: getCurrentDate(),
//   });
//   const [notification, setNotification] = useState("");
//   const [useroptions, setUseroptions] = useState([]);
//   const [classoptions, setClassoptions] = useState([]);
//   const [subjectoptions, setSubjectoptions] = useState([]);
//   const [studentoptions, setStudentoptions] = useState([]);
//   const center_id = localStorage.getItem("center_id");
//   // const [roptions, setRoptions] = useState([]);
//   // const [uoptions, setUoptions] = useState([]);
//   // const [selectedClass, setSelectedClass] = useState([]);
//   // const [selectedUser, setSelectedUser] = useState([]);
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);

//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };
//   const handleUserSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };
//   const handleAdminSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       admin_id: selectedOption.value,
//     });
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     teacher_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const teacher_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     subject_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);

//       // Start with the "General" option
//       const namelist = [{ value: 0, label: "General" }];

//       // Add other subjects from the API response
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id;
//         namelist.push({ value: id, label: name });
//       }

//       console.log(namelist);
//       setSubjectoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   const handleStudentSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       student_id: selectedOption.value.id,
//       class_id: selectedOption.value.class_id, // Automatically set class_id
//     });
//   };
//   useEffect(() => {
//     student_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const student_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/student_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         const id = data.data[i].id;
//         const class_id = data.data[i].class_id; // Get class_id from response
//         const class_name = data.data[i].class_name; // Get class_name from response
//         namelist.push({
//           value: {
//             id: id,
//             class_id: class_id,
//           },
//           label: `${name} (${class_name})`,
//           class_id: class_id, // Also store class_id separately for easy access
//         });
//       }
//       console.log(namelist);
//       setStudentoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("user_id", inputValues.user_id);
//     formData.append("student_id", inputValues.student_id);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("subject_id", inputValues.subject_id);
//     formData.append("admin_id", inputValues.admin_id);
//     formData.append("attendance_date", inputValues.attendance_date);
//     formData.append("status", inputValues.status || 1);
//     try {
//       const response = await fetch(`${serverUrl}/add_student_attendance`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();
//       console.log("Response from API", data.code);

//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Student Attendance added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/student-attendance");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Something went wrong!");
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         file
//                                     }
//                                     alt=""
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {/* <div className="formInput">
//                                         <label htmlFor="file">
//                                             Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                                         </label>
//                                         <input
//                                             type="file"
//                                             id="file"
//                                             onChange={(e) => setFile(e.target.files[0])}
//                                             style={{ display: "none" }}
//                                         />
//                                     </div> */}
//                   {studentattendanceInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "attendance_date" ? (
//                         <input
//                           type="date"
//                           name={input.fieldName}
//                           onChange={handleInputChange}
//                           value={inputValues.attendance_date}
//                           required
//                         />
//                       ) : input.fieldName === "subject_id" ? (
//                         <Select
//                           options={subjectoptions}
//                           name={input.fieldName}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={classoptions}
//                           name={input.fieldName}
//                           value={classoptions.find(
//                             (option) => option.value === inputValues.class_id
//                           )}
//                           onChange={handleClassSelectChange}
//                           isDisabled={true} // Make it read-only
//                           required
//                         />
//                       ) : input.fieldName === "student_id" ? (
//                         <Select
//                           options={studentoptions}
//                           name={input.fieldName}
//                           onChange={handleStudentSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusoptions}
//                           name={input.fieldName}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "admin_id" ? (
//                         <Select
//                           options={useroptions}
//                           name={input.fieldName}
//                           onChange={handleAdminSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "user_id" ? (
//                         <Select
//                           options={useroptions}
//                           name={input.fieldName}
//                           onChange={handleUserSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           onChange={handleInputChange}
//                           required={input.fieldName !== "status"}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default StudentAttendanceNew;

import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { studentattendanceInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 0, label: "Absent" },
  { value: 1, label: "Present" },
  { value: 2, label: "Late" },
  { value: 3, label: "Leave" },
  { value: 4, label: "Half Leave" },
];

const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const StudentAttendanceNew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    attendance_date: getCurrentDate(),
  });
  const [userOptions, setUserOptions] = useState([]);
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);
  const center_id = localStorage.getItem("center_id");
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    alert("Please Login first then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    fetchTeacherNames();
    fetchClassNames();
    fetchSubjectNames();
    fetchStudentNames();
    fetchUserNames();
  }, []);

  const fetchTeacherNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/teacher_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch teachers");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setTeacherOptions(nameList);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      toast.error("Failed to fetch teacher data");
    }
  };
  const fetchUserNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch users");
      const data = await response.json();

      // Filter users who have "Admin" in their role_names_array
      const nameList = data.data
        .filter(
          (user) =>
            user.role_names_array && user.role_names_array.includes("Admin")
        )
        .map(({ id, name }) => ({
          value: id,
          label: name,
        }));

      setUserOptions(nameList);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch user data");
    }
  };
  const fetchClassNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch classes");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setClassOptions(nameList);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to fetch class data");
    }
  };

  const fetchSubjectNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch subjects");
      const data = await response.json();

      // Start with the "General" option
      const nameList = [{ value: 0, label: "General" }];

      // Add other subjects from the API response
      data.data.forEach(({ id, name }) => {
        nameList.push({ value: id, label: name });
      });

      setSubjectOptions(nameList);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to fetch subject data");
    }
  };

  const fetchStudentNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/student_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch students");
      const data = await response.json();
      const nameList = data.data.map(({ id, name, class_id, class_name }) => ({
        value: {
          id: id,
          class_id: class_id,
        },
        label: `${name} (${class_name})`,
        class_id: class_id,
      }));
      setStudentOptions(nameList);
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error("Failed to fetch student data");
    }
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUserSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      user_id: selectedOption.value,
    });
  };

  const handleAdminSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      admin_id: selectedOption.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleSubjectSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      subject_id: selectedOption.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      class_id: selectedOption.value,
    });
  };

  const handleStudentSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      student_id: selectedOption.value.id,
      class_id: selectedOption.value.class_id,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("user_id", inputValues.user_id);
    formData.append("student_id", inputValues.student_id);
    formData.append("class_id", inputValues.class_id);
    formData.append("subject_id", inputValues.subject_id);
    formData.append("admin_id", inputValues.admin_id);
    formData.append("attendance_date", inputValues.attendance_date);
    formData.append("status", inputValues.status || 1);

    try {
      const response = await fetch(`${serverUrl}/add_student_attendance`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Student Attendance added successfully!");
        setInputValues({ attendance_date: getCurrentDate() });
        setTimeout(() => {
          navigate("/student-attendance");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {studentattendanceInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "attendance_date" ? (
                              <input
                                type="date"
                                name={input.fieldName}
                                onChange={handleInputChange}
                                value={inputValues.attendance_date}
                                required
                                className="dateInput"
                              />
                            ) : input.fieldName === "subject_id" ? (
                              <Select
                                options={subjectOptions}
                                onChange={handleSubjectSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "class_id" ? (
                              <Select
                                options={classOptions}
                                value={classOptions.find(
                                  (option) =>
                                    option.value === inputValues.class_id
                                )}
                                onChange={handleClassSelectChange}
                                isDisabled={true}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "student_id" ? (
                              <Select
                                options={studentOptions}
                                onChange={handleStudentSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "admin_id" ? (
                              <Select
                                options={userOptions}
                                onChange={handleAdminSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "user_id" ? (
                              <Select
                                options={teacherOptions}
                                onChange={handleUserSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required={input.fieldName !== "status"}
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/student-attendance")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Create Attendance
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default StudentAttendanceNew;
